<!--The content below is only a placeholder and can be replaced.-->
<div id="refreshElem"></div>
<!-- <app-header></app-header> -->
<ngx-ui-loader></ngx-ui-loader>
<router-outlet></router-outlet>
